export class FinancialStatusYears {
    ID:number;
CLIENT_ID:number;
YEAR1_NAME:string;
YEAR2_NAME:string;

}